import React from 'react';
import {Box, Typography} from '@mui/material';
import {DatePicker} from '@/pages/components/common';

export interface ProgramDateFieldProps {
    value: string;
    onChange: (value: string) => void;
    /** Caption under the field. Default `"Date"`; pass `false` to hide. */
    caption?: string | false;
    placeholder?: string;
    fullWidth?: boolean;
    error?: boolean;
    helperText?: React.ReactNode;
    name?: string;
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

/**
 * Audit-program date field: DD/MM/YYYY picker + optional caption under the input
 * (Excel signature / header date cells).
 */
export default function ProgramDateField({
    value,
    onChange,
    caption = 'Date',
    placeholder = 'dd/mm/yyyy',
    fullWidth = true,
    error,
    helperText,
    name,
    onBlur,
}: ProgramDateFieldProps) {
    return (
        <Box sx={{minWidth: 0, width: fullWidth ? '100%' : undefined}}>
            <DatePicker
                value={value?.trim() ? value : null}
                onChange={(next) => onChange(next ?? '')}
                placeholder={placeholder}
                fullWidth={fullWidth}
                compact
                align="left"
                error={error}
                helperText={helperText}
                name={name}
                onBlur={onBlur}
            />
            {caption !== false ? (
                <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{display: 'block', mt: 0.25, lineHeight: 1.25}}
                >
                    {caption}
                </Typography>
            ) : null}
        </Box>
    );
}
